var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.05 2H7.95C4.66391 2 2 4.66391 2 7.95V16.05C2 19.3361 4.66391 22 7.95 22H16.05C19.3361 22 22 19.3361 22 16.05V7.95C22 4.66391 19.3361 2 16.05 2Z",
    fill: "url(#paint0_linear_406_14022)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79086 10.1499C7.3953 10.1499 7.00862 10.0326 6.67972 9.81284C6.35082 9.59308 6.09448 9.28072 5.9431 8.91527C5.79172 8.54982 5.75212 8.14768 5.82929 7.75972C5.90646 7.37176 6.09694 7.01539 6.37665 6.73569C6.65635 6.45598 7.01272 6.2655 7.40068 6.18833C7.78864 6.11116 8.19077 6.15077 8.55623 6.30214C8.92168 6.45352 9.23404 6.70986 9.4538 7.03876C9.67356 7.36766 9.79086 7.75434 9.79086 8.1499C9.79086 8.68034 9.58015 9.18904 9.20507 9.56412C8.83 9.93919 8.32129 10.1499 7.79086 10.1499ZM22.0009 15.3899L19.7109 13.0799C19.4115 12.7743 19.0525 12.5336 18.6562 12.3726C18.2598 12.2117 17.8346 12.134 17.407 12.1443C16.9793 12.1546 16.5584 12.2527 16.1702 12.4326C15.7821 12.6125 15.4351 12.8703 15.1509 13.1899L13.1509 15.3599C12.9524 15.5823 12.7117 15.7631 12.4428 15.8917C12.1739 16.0204 11.8821 16.0943 11.5843 16.1092C11.2866 16.124 10.9889 16.0796 10.7085 15.9785C10.428 15.8773 10.1705 15.7214 9.95086 15.5199C9.39828 15.0177 8.68439 14.7296 7.93804 14.7076C7.19169 14.6856 6.46206 14.9312 5.88086 15.3999L2.38086 18.2199C2.80831 19.3339 3.56403 20.2919 4.54796 20.9669C5.5319 21.6419 6.69765 22.0021 7.89086 21.9999H16.1009C17.6748 21.9737 19.1753 21.33 20.279 20.2076C21.3827 19.0852 22.0011 17.574 22.0009 15.9999V15.3899Z",
    fill: "url(#paint1_linear_406_14022)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_14022",
    x1: 2,
    y1: 12,
    x2: 22,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_406_14022",
    x1: 2.38086,
    y1: 14.0749,
    x2: 22.0009,
    y2: 14.0749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.4222c641ae0401c356bd4d7cdf65520c.svg";
export { ForwardRef as ReactComponent };